import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'blurry-backdrop-image',
  templateUrl: './blurry-backdrop-image.component.html',
  styleUrls: ['./blurry-backdrop-image.component.scss']
})
export class BlurryBackdropImageComponent {
  @Input() image: string;
  @Input() width: number;
  @Input() height: number;

  @Output() afterLoaded: EventEmitter<any> = new EventEmitter<any>();
  @Output() error: EventEmitter<any> = new EventEmitter<any>();
  public hasError = false;

  afterLoadingImage() {
    this.afterLoaded.emit();
  }

  loadImageError() {
    this.hasError = true;
    this.error.emit();
    this.image = 'assets/images/No_Image.png';
  }

}



// WEBPACK FOOTER //
// ./src/app/core/blurry-backdrop-image/blurry-backdrop-image.component.ts